/// <reference path="../_all.ts" />

module shoppinglist {
  'use strict';
  
  selectOnClickDirective.$inject = [];
  export function selectOnClickDirective(): ng.IDirective {
    return {
      restrict: 'A'
      , link: function (scope: IShoppingListDirectiveDirectiveScope, element: JQuery, attr: ng.IAttributes) {
        element.on('click', function () {
            (<any>this).select(); //@TODO richtiger typ finden…
        });
      }
    }
  }
}
